import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/home_page',
    },
    {
      path: '/products',
      redirect: '/products/productCente',
    },
    {
      path: '/programme',
      redirect: '/programme/indusSolutionGovern',
    },
    {
      path: '/news',
      redirect: '/news/newsHy',
    },
    {
      path: '/about',
      redirect: '/about/aboutUs',
    },
    {
      path: '/',
      name: 'home',
      component: resolve => require(['@/views/Home.vue'], resolve),
      children: [{
        path: 'home_page',
        component: resolve => require(['@/views/home_page.vue'], resolve),

      },{
        name:'productCente',
        path: 'products/productCente',
        component: resolve => require(['@/views/pages/products/productCente.vue'], resolve),
      },{
        name:'productDownload',
        path: 'products/productDownload',
        component: resolve => require(['@/views/pages/products/productDownload.vue'], resolve),
      },{
        name:'indusSolutionGovern',
        path: 'programme/indusSolutionGovern',
        component: resolve => require(['@/views/pages/programme/indusSolutionGovern.vue'], resolve),
      },{
        name:'indusSolutionAffair',
        path: 'programme/indusSolutionAffair',
        component: resolve => require(['@/views/pages/programme/indusSolutionAffair.vue'], resolve),
      },{
        name:'indusSolutionSecure',
        path: 'programme/indusSolutionSecure',
        component: resolve => require(['@/views/pages/programme/indusSolutionSecure.vue'], resolve),
      },{
        name:'indusSolutionTour',
        path: 'programme/indusSolutionTour',
        component: resolve => require(['@/views/pages/programme/indusSolutionTour.vue'], resolve),
      },{
        name:'indusSolutionRent',
        path: 'programme/indusSolutionRent',
        component: resolve => require(['@/views/pages/programme/indusSolutionRent.vue'], resolve),
      },{
        name:'lawProtect',
        path: 'lawProtect',
        component: resolve => require(['@/views/pages/lawProtect/lawProtect.vue'], resolve),
      },{
        name:'newsHy',
        path: '/news/newsHy/:newsType',
        component: resolve => require(['@/views/pages/news/newsHy.vue'], resolve),
      },{
        name:'news_details',
        path: '/news/news_details/:newsId/:newsType',
        component: resolve => require(['@/views/pages/news/news_details.vue'], resolve),
      },{
        name:'aboutUs',
        path: '/about/aboutUs',
        component: resolve => require(['@/views/pages/about/aboutUs.vue'], resolve),
      },{
        name:'helpCenterDetails',
        path: '/about/helpCenterDetails/:newsId',
        component: resolve => require(['@/views/pages/about/helpCenterDetails.vue'], resolve),
      },{
        name:'aboutUsAddress',
        path: '/about/aboutUsAddress',
        component: resolve => require(['@/views/pages/about/aboutUsAddress.vue'], resolve),
      },{
        name:'aboutUsEmploy',
        path: '/about/aboutUsEmploy',
        component: resolve => require(['@/views/pages/about/aboutUsEmploy.vue'], resolve),
      },{
        name:'aboutUsEmployDetail',
        path: '/about/aboutUsEmployDetail/:id',
        component: resolve => require(['@/views/pages/about/aboutUsEmployDetail.vue'], resolve),
      },{
        name:'helpCenter',
        path: '/about/helpCenter',
        component: resolve => require(['@/views/pages/about/helpCenter.vue'], resolve),
      },{
        name:'contractIden',
        path: '/contractIden',
        component: resolve => require(['@/views/pages/contractIden/contractIden.vue'], resolve),
      },{
        name:'contractIdenResult',
        path: '/contractIdenResult/:contracturi',
        component: resolve => require(['@/views/pages/contractIden/contractIdenResult.vue'], resolve),
      }
      ]
    },
    

  ]

})

